import axios from 'crypto-fetch/axios'

export const checkLastestCommentary = (eventId = '') => {
  return axios.get(`/gossip/commentary/latest-commentary?eventId=${eventId}`)
}
